{
    "Profile_Summary_Header.incompleteHeader": "FR: Nearly there!",
    "Profile_Summary_Header.incompleteLabel": "FR: Still some more details needed for the next step.",
    "Profile_Summary_Header.submittedHeader": "FR: 10-4",
    "Profile_Summary_Header.submittedLabel": "FR: We are reviewing your application.",
    "Profile_Summary_Header.acceptedHeader": "FR: All clear!",
    "Profile_Summary_Header.acceptedLabel": "FR: Your application cleared our checks, we are working on finding the best quotes for you.",
    "Profile_Summary_Header.rejectedHeader": "FR: Oh dear!",
    "Profile_Summary_Header.rejectedLabel": "FR: Some of our checks on your application showed problems, contact us for more details.",
    "Profile_Summary_Header.declinedHeader": "FR: Declined",
    "Profile_Summary_Header.declinedLabel": "FR: This referral has been declined.",
    "Profile_Summary_Header.referredHeader": "FR: Oh dear!",
    "Profile_Summary_Header.referredLabel": "FR: Some of our checks on your application showed problems, contact us for more details.",
    "Profile_Summary_Header.underwritingRequiredHeader": "FR: Oh dear!",
    "Profile_Summary_Header.underwritingRequiredLabel": "FR: Some of our checks on your application showed problems, contact us for more details.",
    "Profile_Summary_Header.cancelledHeader": "FR: Oh dear!",
    "Profile_Summary_Header.cancelledLabel": "FR: This quote was cancelled.",
    "Profile_Summary_Header.quotedHeader": "FR: We've shopped around for you!",
    "Profile_Summary_Header.quotedLabel": "FR: And found some great deals. See all the details below.",
    "Profile_Summary_Header.quoteIssuedHeader": "FR: We've shopped around for you!",
    "Profile_Summary_Header.quoteIssuedLabel": "FR: And found some great deals. See all the details below.",
    "Profile_Summary_Header.quoteAcceptedHeader": "FR: Great!",
    "Profile_Summary_Header.quoteAcceptedLabel": "FR: Don't forget to review the nitty-gritties below.",
    "Profile_Summary_Header.lostHeader": "FR: Lost!",
    "Profile_Summary_Header.lostLabel": "FR: Kate, we have to go back!",
    "Profile_Summary_Header.abandonedHeader": "FR: Abandon Ship!",
    "Profile_Summary_Header.abandonedLabel": "FR: This submission was abandoned along the way!",
    "Profile_Summary_Header.bindRequestedHeader": "FR: The ball is in our court!",
    "Profile_Summary_Header.bindRequestedLabel": "FR: You're in the home stretch. You will be notified by email when the customer completes the payment.",
    "Profile_Summary_Header.boundHeader": "FR: We've got that ball rolling!",
    "Profile_Summary_Header.boundLabel": "FR: We'll reach out when we've collected all of your official documentation.",
    "Profile_Summary_Header.issuedHeader": "FR: You're all done!",
    "Profile_Summary_Header.issuedLabel": "FR: Download your policy documents below.",
    "Profile_Summary_Header.quotingHeader": "FR: Nearly there!",
    "Profile_Summary_Header.quotingLabel": "FR: Your Quote is being calculated.",

    "Profile_Summary_Header.Badge.Authorized": "FR: Authorized",
    "Profile_Summary_Header.Badge.NotAuthorized": "FR: Not Authorized",
    "Profile_Summary_Header.Badge.PolicyIssued": "FR: Policy Documents Issued",
    "Profile_Summary_Header.Badge.ProposalIssued": "FR: Proposal Issued",
    "Profile_Summary_Header.Badge.NotIssued": "FR: Policy Documents Not Issued",
    "Profile_Summary_Header.Badge.Paid": "FR: Paid",
    "Profile_Summary_Header.Badge.NotPaid": "FR: Not Paid",
    "Profile_Summary_Header.Badge.None": "FR: None",
    "Profile_Summary_Header.Badge.Incomplete": "FR: Incomplete",
    "Profile_Summary_Header.Badge.Submitted": "FR: Submitted",
    "Profile_Summary_Header.Badge.Abandoned": "FR: Abandoned",
    "Profile_Summary_Header.Badge.Accepted": "FR: Accepted",
    "Profile_Summary_Header.Badge.Declined": "FR: Declined",
    "Profile_Summary_Header.Badge.Quoted": "FR: Quoted",
    "Profile_Summary_Header.Badge.QuotedIndicative": "FR: Quoted (indicative)",
    "Profile_Summary_Header.Badge.UnderwritingRequired": "FR: Underwriting Required",
    "Profile_Summary_Header.Badge.Referred": "FR: Referred",
    "Profile_Summary_Header.Badge.QuoteIssued": "FR: Quote Issued",
    "Profile_Summary_Header.Badge.BindRequested": "FR: Bind Requested",
    "Profile_Summary_Header.Badge.Bound": "FR: Bound",
    "Profile_Summary_Header.Badge.Issued": "FR: Issued",
    "Profile_Summary_Header.Badge.Lost": "FR: Lost",
    "Profile_Summary_Header.Badge.Cancelled": "FR: Cancelled",
    "Profile_Summary_Header.Badge.QuoteAccepted": "FR: Quote Accepted",
    "Profile_Summary_Header.Badge.Quoting": "FR: Quoting"
}
